// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__8WnWC","title":"Images90_title__VBnvb","images":"Images90_images__MJXl5"};